// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promo[data-v-510d6242] {\n  display: block;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.title[data-v-510d6242] {\n  font-weight: bold;\n  font-size: 1.9rem;\n  text-align: center;\n  line-height: 1.1;\n  margin-top: 1rem;\n}\n.title + .title[data-v-510d6242] {\n  margin-top: 0.6rem;\n}\n.product-info[data-v-510d6242] {\n  color: #323653;\n  font-size: 0.9rem;\n  margin: 1rem 0;\n  opacity: 0.8;\n}", ""]);
// Exports
module.exports = exports;
